import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useTableStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    table: {
      // minWidth: 750,
    },
    tablehead: {
      fontWeight: 'bold'
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    cellAttach: {
      paddingRight: 0,
      textAlign: 'right',
      // width: 40
    },
    cellUnread: {
      fontWeight: 'bold'
    },
    cellDate: {
      // whiteSpace: 'nowrap',
      // width: 100
    },
    cellChecked: {
      padding: 0
    }
  }),
)
export const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    top: {
      paddingRight: theme.spacing(2),
    },
    filterWrap: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      marginBottom: theme.spacing(2),
      background: 'white'
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 240
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    filter: {
      marginLeft: 'auto'
    },
    break: {
      flexBasis: '100%',
      height: 0
    }

  }),
)
